module.exports = __webpack_public_path__ + "static/media/coach.ee0597fc.png";